var base_url = "https://backend-vonagevrcpev2.herokuapp.com"

if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('panelbtn', {
  schema: {
    on: {
      default: 'click'
    },
    width: {
      type: 'number',
      default: 0.75
    },
    height: {
      type: 'number',
      default: 0.125
    },
    toggle: {
      type: 'boolean',
      default: false
    },
    base: {
      type: 'string',
      default: '#bookmark-btn-label'
    },
    hover: {
      type: 'string',
      default: '#bookmark-btn-label-hover'
    },
    click: {
      type: 'string',
      default: '#bookmark-btn-label-click'
    },
    clickAction: {
      type: 'string'
    },
    hoversnd: { type: 'string', default: 'panelhoversound' },
    clicksnd: { type: 'string', default: 'panelclicksound' },        
  },

  init: function () {
    var data = this.data;
    var el = this.el;
    var toggleState = this.toggleState = data.toggle;
    var hoversound = this.opensound = document.getElementById(data.hoversnd);
    var clicksound = this.coinsound = document.getElementById(data.clicksnd);
    el.setAttribute('geometry', `primitive: plane; height: ${data.height}; width: ${data.width};`);
    el.setAttribute('material', `transparent: true; opacity:1; color:#fff; src:${data.base};`);

    el.addEventListener('mouseenter', function () {
      if (!(data.toggle)) {
        this.setAttribute('material', 'src', data.hover);
      }
      this.setAttribute('scale', '1.15 1.15 1.15');
      hoversound.components.sound.stopSound(); hoversound.components.sound.playSound();
    });

    el.addEventListener('mouseleave', function () {
      if (!(data.toggle)) {
        this.setAttribute('material', 'src', data.base);
      }
      this.setAttribute('scale', '1 1 1');
    });

    el.addEventListener('mousedown', function () {
      if (!(data.toggle)) {
        this.setAttribute('material', 'src', data.click);
      } else {
        this.setAttribute('material', 'src', data.hover);
      }
    });
    el.addEventListener('mouseup', function () {
      if (!(data.toggle)) {
        this.setAttribute('material', 'src', data.hover);
      } else {
        this.setAttribute('material', 'src', data.click);
      }
    });

    el.addEventListener(data.on, function (evt) {

      console.log('I was clicked at: ', evt.detail.intersection.point);

      clicksound.components.sound.stopSound(); clicksound.components.sound.playSound();

      var clickActionFunctionName = data.clickAction;
      console.log("in button, clickActionFunctionName: " + clickActionFunctionName);

      //BOOKMARK SERVICE USER CLICKS
      //Param: 'bookmarkvonagereach'
      if (clickActionFunctionName.includes("bookmark")) {
        var user = JSON.parse(localStorage.getItem('active_user'));
        user["bookmarkedService"] = clickActionFunctionName.split("bookmark")[1];

        userBookmarkService(user);
      }
      // find object
      var clickActionFunction = window[clickActionFunctionName];
      //console.log("clickActionFunction: "+clickActionFunction);
      // is object a function?
      if (typeof clickActionFunction === "function") clickActionFunction();
    });

  },
  setClickAction: function (action) {
    this.data.clickAction = action; //change function dynamically
  },
  play: function () {

  },
  update: function (oldData) {
    console.log("In button update, toggle: " + this.toggleState);
  },
  setActiveState: function (activeState) {
    console.log("in setActiveState function");
    this.data.toggle = this.toggleState = activeState;
    if (!activeState) {
      this.setAttribute('material', 'src', this.data.base);
    } else {

    }
  },
});

function userBookmarkService(user) {
  console.log("Bookmarking: ", user.bookmarkedService, " for ", user.email)

  $.ajax({
    url: base_url + '/user',
    type: 'GET',
    dataType: 'jsonp',
    data: user,
    success: function (data) {
      return data
    },
    error: function (err) {
      console.log('Failed!', err);
      return err
    }
  });

}



// WEBPACK FOOTER //
// ./src/aframe/components/panelbtn.js